/// <reference path="../../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Nobox {

    import fld = CampaignresultRow.Fields;

    @Serenity.Decorators.registerClass()
    export class LinkBroadcastGrid extends NoboxEntityGrid<CampaignresultRow, any> {
        protected getDialogType() { return CampaignresultDialog; }
        protected getColumnsKey() { return LinkBroadcastColumns.columnsKey; }
        protected getIdProperty() { return CampaignresultRow.idProperty; }
        protected getInsertPermission() { return CampaignresultRow.insertPermission; }
        protected getLocalTextPrefix() { return CampaignresultRow.localTextPrefix; }
        protected getService() { return CampaignresultService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        hideButton(cssClass, aktif) {
            this.element.find(`.${cssClass}`).first().toggle(aktif);
            this.element.find(`.${cssClass}`).first().parent().toggle(aktif);
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected getButtons() {
            var btn = super.getButtons();
            btn.splice(0, 1);
            return btn;
        }

        protected getColumns(): Slick.Column[] {
            var columns = super.getColumns();
            var processBy = Q.getLookup("Nobox.AccountLookup").itemById;
            Q.first(columns, x => x.field == CampaignresultRow.Fields.ProcessBy).format =
                ctx => {
                    if (processBy[ctx.value] != undefined) {
                        return `<a href="javascript:;" class="account-link">${Q.htmlEncode(processBy[ctx.value].Name)}</a>`;
                    } else {
                        return "";
                    }
                };
            //Q.first(columns, x => x.field == CampaignresultRow.Fields.Contact).format =
            //    ctx => {
            //        return `<a href="javascript:;" class="contact-link">${Q.htmlEncode(ctx.value)}</a>`;
            //    };

            return columns;
        }

        protected addButtonClick() {
            this.editItem({ ContactLinkId: this.contactlinkid });
        }

        protected getPersistanceStorage(): Serenity.SettingStorage {
            return window.localStorage;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.contactlinkid;
        }

        private _ContactLinkId: string;

        get contactlinkid() {
            return this._ContactLinkId;
        }
        set contactlinkid(value: string) {
            if (this._ContactLinkId !== value) {
                this._ContactLinkId = value;
                this.refresh();
            } else {
                this.refresh();
            }
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            request.EqualityFilter.ContactLinkId= this.contactlinkid;
            return true;
        }
    }
}